import { render, staticRenderFns } from "./newRegisterCategory.vue?vue&type=template&id=6a18a6fc&"
import script from "./newRegisterCategory.js?vue&type=script&lang=js&"
export * from "./newRegisterCategory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports